interface Feature {
  icon: string;
  title: string;
  description: string;
}

const features: Feature[] = [
  {
    icon: 'ri-article-line',
    title: '下拉式阅读',
    description: '独特的韩漫下拉式浏览模式，无需翻页等待，一气呵成的阅读体验，让您沉浸在漫画世界中。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    description: '完美适配手机、平板和电脑，无论使用什么设备都能享受流畅的在线阅读体验。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    description: '热门连载韩漫每日更新，第一时间为您呈现最新章节，不再错过任何精彩内容。',
  },
  {
    icon: 'ri-bookmark-line',
    title: '丰富分类',
    description: '涵盖恋爱、奇幻、动作、悬疑、校园等多元类型，满足不同读者的阅读喜好。',
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-medium text-primary-500 bg-primary-50 px-3 py-1 rounded-full mb-4 whitespace-nowrap">
            核心阅读体验
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
            为什么选择韩国漫画网
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            我们专注于打造极致的韩漫在线阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <article
              key={index}
              className="group bg-background-50 border border-background-200/70 rounded-lg p-6 transition-all duration-300 hover:bg-primary-500 hover:border-primary-500 hover:-translate-y-1 cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-secondary-100 rounded-lg group-hover:bg-background-50/20 transition-colors duration-300">
                <i className={`${feature.icon} text-xl text-secondary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mt-4 group-hover:text-background-50 transition-colors duration-300">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 mt-2 leading-relaxed group-hover:text-background-200 transition-colors duration-300">
                {feature.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}